// Probe ``/admin/health`` once per session to determine whether the
// authenticated user is an admin. Backend gates this route on
// `ADMIN_EMAILS` and returns 404 for everyone else.
//
// Cached aggressively (Infinity stale, no refetch on focus) so the
// admin status doesn't flap mid-session.

import { useQuery } from "@tanstack/react-query";

import { fetchAdminHealth } from "@/services/api/admin";

export interface UseIsAdminResult {
  isAdmin: boolean;
  isLoading: boolean;
}

export function useIsAdmin(): UseIsAdminResult {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["admin", "health"],
    queryFn: fetchAdminHealth,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
  return {
    isAdmin: Boolean(data?.ok) && !isError,
    isLoading,
  };
}
